// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#expertModal .modal-dialog {
  transform: none;
}

.authorOpen #expertModal .modal-content {
  transition: transform 0.3s;
}

#expertModal .modal-content {
  background-color: #fff;
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;
  padding: 82px 73px 64px;
  overflow: hidden;
  transition: transform 0.3s;
}
@media (max-width: 991.98px) {
  #expertModal .modal-content {
    padding: 70px 30px;
  }
}
@media (max-width: 767.98px) {
  #expertModal .modal-content {
    padding: 70px 15px;
  }
}

.consultantDetail.showAsDetail {
  margin-top: 37px;
}
.consultantDetail .consultantInfoContainer {
  display: flex;
  align-items: flex-start;
  margin: 0 115px;
}
@media (max-width: 1250px) {
  .consultantDetail .consultantInfoContainer {
    margin: 0;
  }
}
@media (max-width: 767.98px) {
  .consultantDetail .consultantInfoContainer {
    flex-wrap: wrap;
  }
  .consultantDetail .consultantInfoContainer .textContainer {
    order: 1;
    padding: 0 !important;
  }
}
.consultantDetail.showAsDetail .consultantInfoContainer {
  margin-right: auto;
  margin-left: auto;
  max-width: 1130px;
}
.consultantDetail .claim {
  color: #005790;
  font-size: 16px;
}
.consultantDetail .claim:before {
  content: "/";
  display: inline-block;
  padding-right: 9px;
}
.consultantDetail .name {
  color: #005790;
  margin-top: 6px;
  margin-bottom: 20px;
}
.consultantDetail .informationText {
  font-size: 18px;
}
.consultantDetail .logoContainer {
  flex-shrink: 0;
  margin-left: 30px;
}
@media (max-width: 767.98px) {
  .consultantDetail .logoContainer {
    order: 0;
    margin-left: 0;
    margin-bottom: 30px;
  }
}
.consultantDetail .furtherInformationContainer {
  display: flex;
  gap: 40px 0;
  margin-top: 77px;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: 50px;
  flex-wrap: wrap;
}
@media (max-width: 767.98px) {
  .consultantDetail .furtherInformationContainer {
    gap: 15px 0;
    margin-top: 50px;
  }
}
.consultantDetail .contactContainer,
.consultantDetail .servicesContainer,
.consultantDetail .linksContainer {
  padding-left: 20px;
  padding-right: 20px;
}
@media (max-width: 1250px) {
  .consultantDetail .servicesContainer,
  .consultantDetail .contactContainer {
    flex-basis: 50%;
    max-width: 50%;
  }
}
@media (max-width: 767.98px) {
  .consultantDetail .servicesContainer,
  .consultantDetail .contactContainer {
    flex-basis: 100%;
    max-width: 100%;
  }
}
@media (max-width: 1250px) {
  .consultantDetail .linksContainer {
    flex-basis: 100%;
    max-width: 100%;
  }
}
.consultantDetail .boxContainer {
  padding: 43px 40px 45px;
  background-color: #f8f7f4;
  font-size: 18px;
  height: 100%;
}
.consultantDetail .boxContainer .data,
.consultantDetail .boxContainer strong {
  display: block;
  font-size: 16px;
  line-height: 30px;
}
.consultantDetail .boxContainer .headline {
  font-size: 18px;
  margin-bottom: 20px;
}
.consultantDetail .boxContainer .lni-external-link {
  padding-left: 10px;
  font-size: 16px;
  position: relative;
  top: -3px;
  font-weight: bold;
}
.consultantDetail .address,
.consultantDetail .contactData {
  margin-bottom: 20px;
}
.consultantDetail .address .lni,
.consultantDetail .contactData .lni {
  font-size: 20px;
  margin-right: 10px;
  color: #005790;
}
.consultantDetail .address .contactLink,
.consultantDetail .contactData .contactLink {
  color: #5f5e5c;
  display: flex;
  align-items: center;
}
.consultantDetail .address .contactLink:hover,
.consultantDetail .contactData .contactLink:hover {
  color: #005790;
}
.consultantDetail .contactLinks,
.consultantDetail .externalLinks {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.consultantDetail .externalLink + .externalLink {
  margin-top: 15px;
}
.consultantDetail .buttonContainer .btn {
  margin-left: auto;
  margin-right: auto;
}

.cooperationitem {
  display: block !important;
}
.cooperationitem .articleContent:hover .imageContainer:after {
  box-shadow: none;
}
.cooperationitem .articleContent:hover .bigHeadline {
  background-size: 0px 100%;
}
.cooperationitem.expertItem .textContainer {
  pointer-events: all;
}

a.external_link.lni-external-link {
  color: #3dbea2;
  font-weight: bold;
  position: relative;
}
a.external_link.lni-external-link:after {
  content: "\\e904";
  font-family: "LineIcons";
  font-size: 16px;
  position: relative;
  left: 5px;
  top: 1px;
}
a.external_link.lni-external-link:before {
  content: "";
  position: absolute;
  bottom: -5px;
  display: block;
  height: 2px;
  width: 23px;
  background-color: #3dbea2;
  transition: width 0.3s;
}
a.external_link.lni-external-link:hover:before {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./build/scss/_experts-and-consultants.scss","webpack://./build/scss/bootstrap/mixins/_breakpoints.scss","webpack://./build/scss/_variables.scss"],"names":[],"mappings":"AAKA;EACI,eAAA;AAJJ;;AAOA;EACI,0BAAA;AAJJ;;AAWI;EACI,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;AARR;ACyDI;EDxDA;IAUQ,kBAAA;EAPV;AACF;ACoDI;EDxDA;IAcQ,kBAAA;EANV;AACF;;AAWI;EACI,gBAAA;AARR;AAWI;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AATR;AAWQ;EALJ;IAMQ,SAAA;EARV;AACF;ACiCI;EDhCA;IAUQ,eAAA;EAPV;EASU;IACI,QAAA;IACA,qBAAA;EAPd;AACF;AAWI;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;AATR;AAYI;EACI,cE5CD;EF6CC,eAAA;AAVR;AAYQ;EACI,YAAA;EACA,qBAAA;EACA,kBAAA;AAVZ;AAcI;EACI,cEvDD;EFwDC,eAAA;EACA,mBAAA;AAZR;AAeI;EACI,eAAA;AAbR;AAgBI;EACI,cAAA;EACA,iBAAA;AAdR;ACFI;EDcA;IAKQ,QAAA;IACA,cAAA;IACA,mBAAA;EAbV;AACF;AAgBI;EACI,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAdR;AClBI;EDyBA;IAUQ,WAAA;IACA,gBAAA;EAbV;AACF;AAgBI;;;EAGI,kBAAA;EACA,mBAAA;AAdR;AAmBQ;EAFJ;;IAGO,eAAA;IACA,cAAA;EAfT;AACF;ACrCI;ED+CA;;IAQQ,gBAAA;IACA,eAAA;EAbV;AACF;AAiBQ;EADJ;IAEO,gBAAA;IACA,eAAA;EAdT;AACF;AAiBI;EACI,uBAAA;EACA,yBE5HG;EF6HH,eAAA;EACA,YAAA;AAfR;AAiBO;;EAEK,cAAA;EACA,eAAA;EACA,iBAAA;AAfZ;AAkBQ;EACI,eAAA;EACA,mBAAA;AAhBZ;AAmBQ;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AAjBZ;AAqBI;;EAEI,mBAAA;AAnBR;AAqBQ;;EACI,eAAA;EACA,kBAAA;EACA,cEvJL;AFqIP;AAqBQ;;EACI,cE3IC;EF4ID,aAAA;EACA,mBAAA;AAlBZ;AAoBY;;EACI,cEhKT;AF+IP;AAsBI;;EAEI,aAAA;EACA,sBAAA;EACA,uBAAA;AApBR;AAwBQ;EACI,gBAAA;AAtBZ;AA2BQ;EACI,iBAAA;EACA,kBAAA;AAzBZ;;AA8BA;EACI,yBAAA;AA3BJ;AA8BQ;EACI,gBAAA;AA5BZ;AA+BQ;EACI,yBAAA;AA7BZ;AAiCI;EACI,mBAAA;AA/BR;;AAmCA;EACI,cEzMI;EF0MJ,iBAAA;EACA,kBAAA;AAhCJ;AAkCI;EACI,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAhCR;AAmCI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,yBE7NA;EF8NA,sBAAA;AAjCR;AAoCI;EACI,WAAA;AAlCR","sourcesContent":["@import 'variables';\n@import 'bootstrap/functions';\n@import 'bootstrap/variables';\n@import 'bootstrap/mixins';\n\n#expertModal .modal-dialog {\n    transform: none;\n}\n\n.authorOpen #expertModal .modal-content {\n    transition: transform 0.3s;\n    //transform: scale(1);\n    //animation-name: scaleUp;\n    //animation-duration: 0.31s;\n}\n\n#expertModal {\n    .modal-content {\n        background-color: #fff;\n        max-width: 1500px;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 82px 73px 64px;\n        overflow: hidden;\n        transition: transform 0.3s;\n\n        @include media-breakpoint-down(md) {\n            padding: 70px 30px;\n        }\n\n        @include media-breakpoint-down(sm) {\n            padding: 70px 15px;\n        }\n    }\n}\n\n.consultantDetail {\n    &.showAsDetail {\n        margin-top: 37px;\n    }\n    \n    .consultantInfoContainer {\n        display: flex;\n        align-items: flex-start;\n        margin: 0 115px;\n\n        @media (max-width: 1250px) {\n            margin: 0;\n        }\n\n        @include media-breakpoint-down(sm) {\n            flex-wrap: wrap;\n\n            .textContainer {\n                order: 1;\n                padding: 0 !important;\n            }\n        } \n    }\n\n    &.showAsDetail .consultantInfoContainer {\n        margin-right: auto;\n        margin-left: auto;\n        max-width: 1130px;\n    }\n\n    .claim {\n        color: $blue;\n        font-size: 16px;\n\n        &:before {\n            content: '/';\n            display: inline-block;\n            padding-right: 9px;\n        }\n    }\n\n    .name {\n        color: $blue;\n        margin-top: 6px;\n        margin-bottom: 20px;\n    }\n\n    .informationText {\n        font-size: 18px;\n    }\n\n    .logoContainer {\n        flex-shrink: 0;\n        margin-left: 30px;\n\n        @include media-breakpoint-down(sm) {\n            order: 0;\n            margin-left: 0;\n            margin-bottom: 30px;\n        } \n    }\n\n    .furtherInformationContainer {\n        display: flex;\n        gap: 40px 0;\n        margin-top: 77px;\n        margin-left: -20px;\n        margin-right: -20px;\n        margin-bottom: 50px;\n        flex-wrap: wrap;\n\n        @include media-breakpoint-down(sm) {\n            gap: 15px 0;\n            margin-top: 50px;\n        } \n    }\n\n    .contactContainer,\n    .servicesContainer,\n    .linksContainer {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .servicesContainer,\n    .contactContainer {\n        @media (max-width: 1250px) {\n           flex-basis: 50%; \n           max-width: 50%;\n        } \n\n        @include media-breakpoint-down(sm) {\n            flex-basis: 100%; \n            max-width: 100%;\n        }\n    }\n\n    .linksContainer {\n        @media (max-width: 1250px) {\n           flex-basis: 100%; \n           max-width: 100%;\n       } \n    }\n\n    .boxContainer {\n        padding: 43px 40px 45px;\n        background-color: $gray-100;\n        font-size: 18px;\n        height: 100%;\n\n       .data,\n        strong {\n            display: block;\n            font-size: 16px;\n            line-height: 30px;\n        }\n\n        .headline {\n            font-size: 18px;\n            margin-bottom: 20px;\n        }\n\n        .lni-external-link {\n            padding-left: 10px;\n            font-size: 16px;\n            position: relative;\n            top: -3px;\n            font-weight: bold;\n        }\n    }\n\n    .address,\n    .contactData {\n        margin-bottom: 20px;\n\n        .lni {\n            font-size: 20px;\n            margin-right: 10px;\n            color: $blue;\n        }\n\n        .contactLink {\n            color: $body-color;\n            display: flex;\n            align-items: center;\n\n            &:hover {\n                color: $blue;\n            }\n        }\n    }\n\n    .contactLinks,\n    .externalLinks {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .externalLink {\n        + .externalLink {\n            margin-top: 15px;\n        }\n    }\n\n    .buttonContainer {\n        .btn {\n            margin-left: auto;\n            margin-right: auto;\n        }\n    }\n}\n\n.cooperationitem {\n    display: block !important;\n\n    .articleContent:hover {\n        .imageContainer:after {\n            box-shadow: none;\n        }\n\n        .bigHeadline {\n            background-size: 0px 100%;\n        }\n    }\n\n    &.expertItem .textContainer {\n        pointer-events: all;\n    }\n}\n\na.external_link.lni-external-link {\n    color: $green;\n    font-weight: bold;\n    position: relative;\n\n    &:after {\n        content: '\\e904';\n        font-family: 'LineIcons';\n        font-size: 16px;\n        position: relative;\n        left: 5px;\n        top: 1px;\n    }\n\n    &:before {\n        content: '';\n        position: absolute;\n        bottom: -5px;\n        display: block;\n        height: 2px;\n        width: 23px;\n        background-color: $green;\n        transition: width 0.3s;\n    }\n\n    &:hover:before {\n        width: 100%;\n    }\n}","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02px, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","//\r\n// Project specific variables\r\n// --------------------------------------------------\r\n\r\n//== Transitions\r\n$transition-duration: 300ms !default;\r\n$transition-duration-fast: 150ms !default;\r\n\r\n$page-width:     1600px;\r\n$page-min-width:  320px;\r\n$content-width:  1420px;\r\n\r\n//\r\n// Bootstrap variables\r\n// --------------------------------------------------\r\n\r\n//== Color system\r\n$white: #ffffff;\r\n$gray-100: #f8f7f4;\r\n$gray-200: #ece9e4;\r\n$gray-300: #e0ddd6;\r\n$gray-400: #001f37;\r\n\r\n$blue: #005790;\r\n$blue-light: #aebacc;\r\n$blue-dark: #003151;\r\n$blue-medium: #004471;\r\n$green: #3dbea2;\r\n$green-dark: #228d76;\r\n$red: #ea7c7c;\r\n$red-light: #ed8f8f;\r\n$brown: #d8bc91;\r\n\r\n$primary: $blue;\r\n$secondary: $green;\r\n\r\n\r\n\r\n//== Body\r\n$body-color: #5f5e5c;\r\n\r\n//== Components\r\n$line-height-base: 1.7;\r\n$line-height-lg: 1.7;\r\n$line-height-sm: 1.7;\r\n\r\n//== Fonts\r\n$font-size-base: 1.25rem; // If we don't use rem, we get compile errors...\r\n\r\n//== Fonts\r\n$font-family-sans-serif: 'Gudea', sans-serif;\r\n\r\n$h1-font-size:   38px;\r\n$h1-line-height: 46px;\r\n\r\n$h2-font-size:   30px;\r\n$h2-line-height: 46px;\r\n\r\n// $h3-font-size:   20px;\r\n// $h3-line-height: 30px;\r\n\r\n//== Links\r\n$link-hover-decoration: none;\r\n\r\n$fullwidth-margin-desktop: 120px;\r\n// $fullwidth-margin-desktop: 90px;\r\n$fullwidth-margin-tablet: 70px;\r\n$fullwidth-margin-smartphone: 60px;\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
